import { BaseModel } from "../base.model";

export class ContactDeal extends BaseModel {
  isPrimaryContact: boolean;
}
